import { lazy, Suspense } from 'react';

import type { ModuleWeb } from '../registry.js';

// Écrans de la reconnaissance chargés à la demande (spec 008, espace bénévole simplifié).
const pages = () => import('./EngagementPages.js');
const MonEngagementPage = lazy(() => pages().then((m) => ({ default: m.MonEngagementPage })));
const MesBonsPage = lazy(() => pages().then((m) => ({ default: m.MesBonsPage })));
const gestion = () => import('./GestionPages.js');
const GestionEngagementPage = lazy(() =>
  gestion().then((m) => ({ default: m.GestionEngagementPage })),
);
// Bloc de l'accueil bénévole (chantier Q), dans son propre morceau : l'accueil ne charge pas
// les écrans du module.
const EngagementResume = lazy(() =>
  import('./EngagementResume.js').then((m) => ({ default: m.EngagementResume })),
);
const DecorsPage = lazy(() => gestion().then((m) => ({ default: m.DecorsPage })));
const ProjetsPage = lazy(() => gestion().then((m) => ({ default: m.ProjetsPage })));
const ProgrammeReglagesPage = lazy(() =>
  gestion().then((m) => ({ default: m.ProgrammeReglagesPage })),
);

export const reconnaissanceWeb: ModuleWeb = {
  module: 'reconnaissance',
  routes: [
    { path: '/reconnaissance/mon-engagement', element: <MonEngagementPage /> },
    { path: '/reconnaissance/mes-bons', element: <MesBonsPage /> },
    { path: '/reconnaissance/projets', element: <ProjetsPage /> },
    { path: '/reconnaissance/gestion', element: <GestionEngagementPage /> },
    { path: '/reconnaissance/programme', element: <ProgrammeReglagesPage /> },
    { path: '/reconnaissance/decors', element: <DecorsPage /> },
  ],
  homeBlocks: [
    {
      key: 'mon-engagement',
      path: '/reconnaissance/mon-engagement',
      render: () => (
        <Suspense fallback={null}>
          <EngagementResume />
        </Suspense>
      ),
    },
  ],
};
